import { api } from './api';

const cardOrderDetailsGelAll = async ({data, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `CardOrderDetails/getPagedList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...data,
        },
    });
    return response.data;
};

const getCardOrderDetailsGetAllGsms = async ({data}) => {
    const response = await api({
        url: `CardOrderDetails/getPagedList`,
        method: 'GET',
        params: {
            ...data,
        },
    });
    return response.data;
};

const cardOrderDetailSave = async (data) => {
    const response = await api({
        url: `CardOrderDetails/add`,
        method: 'POST',
        data: data.entity,
    });
    return response.data;
};

const cardOrderDetailUpdate = async (data) => {
    const response = await api({
        url: `CardOrderDetails/update`,
        method: 'PUT',
        data: data.entity,
    });
    return response.data;
};

const cardOrderDetailDelete = async ({id}) => {
    const response = await api({
        url: `CardOrderDetails/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            id,
            customerId: window.customerId
        },
    });
    return response.data;
};

const getCardOrderDetailExcelTemplate = async (data) => {
    const response = await api({
        url: `CardOrderDetails/cardorderdetailexceltemplate`,
        method: 'POST',
        responseType: 'arraybuffer',
        data,
    });
    return response.data;
};

const setCardOrderDetailExcelUpload = async (data) => {
    const response = await api({
        url: `CardOrderDetails/cardorderdetailexcelupload`,
        method: 'POST',
        data,
    });
    return response.data;
};

const cardOrderDetailsServices = {
  cardOrderDetailsGelAll,
  cardOrderDetailSave,
  cardOrderDetailUpdate,
  cardOrderDetailDelete,
  getCardOrderDetailExcelTemplate,
  setCardOrderDetailExcelUpload,
  getCardOrderDetailsGetAllGsms,
};

export default cardOrderDetailsServices;
